import React, { ComponentType, useState } from "react";
import { Button, Box } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import Error from "@/modules/common/components/ui/error";

function WithErrorHandling<T>(WrappedComponent: ComponentType<T>): React.FC<T> {
  return (props: T) => {
    const [hasError, setHasError] = useState(false);

    const handleReload = () => {
      setHasError(false);
    };

    const handleError = () => {
      setHasError(true);
    };

    return (
      <>
        {hasError && (
          <Box
            sx={{
              position: "relative",
              padding: "24px",
              background: muiTheme.colorSchemes.light.palette.background.white,
              borderRadius: 2.5,
              boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.05)",
              display: "flex",
              flexDirection: "column",
              gap: 3,
              width: "100%",
              maxHeight: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Error />

            <Button
              variant="contained"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 2,
                border: "1px solid #D0D5DD",
                color: " #344054",
                background: muiTheme.colorSchemes.light.palette.main.white,
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                textTransform: "none",
                "&:hover": {
                  background: "#F9FAFB",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "&:active": {
                  boxShadow:
                    "0px 0px 0px 4px #F2F4F7, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
              }}
              onClick={handleReload}
            >
              Try Again
            </Button>
          </Box>
        )}
        {!hasError && <WrappedComponent {...props} onError={handleError} />}
      </>
    );
  };
}

export default WithErrorHandling;
